<template>
    <div class="container fondo">
        <img src="../assets/bg/felicitaciones.jpg" alt="" class="bg">
        <img src="../assets/bg/felicitaciones-celular.jpg" alt="" class="bgcel">
    </div>   

</template>

<script>

import  firebaseServices from "@/services/firebaseServices";
import Control from "@/components/Control";
import Fondos from '@/components/Fondos.vue'
export default {

    components:{
        Control,
        Fondos
    },
    methods:{
        saveData(){
            
            let data = {
                usuario: new Date().toISOString(),
            }
            firebaseServices.saveInfo('usuario', data );
        }
    },
    mounted() {
        firebaseServices.setUser();
        //firebaseServices.getUser();
        this.saveData();
    },
}
</script>


